const INVALID_CHARACTERS_REGEX = /[^\d-\.,]|[-](?!\d+)|[,.](?!\d+[^\d\.,]*$)/g;
const MAX_DECIMALS = 3;
const REPLACE_COMMA_REGEX = /,(?=\d+)/g;

function unformat(value: string, min?: number): number | undefined {
    // Remove invalid values
    value = value.replace(INVALID_CHARACTERS_REGEX, '').replace(REPLACE_COMMA_REGEX, '.');

    // Convert to number
    const num = value.length ? Math.round(Number(value) * Math.pow(10, MAX_DECIMALS)) / Math.pow(10, MAX_DECIMALS) : undefined;


    // Ensure is number
    return !isNaN(num) ? Math.max(min ?? num, num) : undefined;
}

export const NumberUtils = {
    unformat
}

export default NumberUtils;